document.addEventListener('DOMContentLoaded', function () {
  let loading = false;

  function getProductGrid() {
    return document.querySelector('#product-grid');
  }

  function getPaginationData() {
    return document.querySelector('#infinite-scroll-data');
  }

  function createLoader() {
  let loader = document.getElementById('infinite-loader');

  if (!loader) {
    loader = document.createElement('div');
    loader.id = 'infinite-loader';

    loader.innerHTML = `
      <div
        class="infinite-spinner"
        role="status"
        aria-label="Loading more products"
      ></div>
    `;
  }

  const productGrid = getProductGrid();

  if (productGrid) {
    productGrid.insertAdjacentElement('afterend', loader);
  }

  return loader;
}

  function showLoader() {
    const loader = createLoader();

    if (loader) {
      loader.classList.add('is-loading');
      loader.setAttribute('aria-hidden', 'false');
    }
  }

  function hideLoader() {
    const loader = document.getElementById('infinite-loader');

    if (loader) {
      loader.classList.remove('is-loading');
      loader.setAttribute('aria-hidden', 'true');
    }
  }

  async function loadMoreProducts() {
    if (loading) return;

    const paginationData = getPaginationData();

    if (!paginationData) return;

    const nextPageUrl = paginationData.dataset.nextUrl;

    if (!nextPageUrl) return;

    loading = true;

    showLoader();

    try {
      const response = await fetch(nextPageUrl, {
        headers: {
          'X-Requested-With': 'XMLHttpRequest'
        }
      });

      if (!response.ok) {
        throw new Error('HTTP error: ' + response.status);
      }

      const html = await response.text();

      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');

      const newGrid = doc.querySelector('#product-grid');
      const currentGrid = getProductGrid();

      if (!newGrid || !currentGrid) {
        throw new Error('Product grid not found');
      }

      const newProducts = Array.from(newGrid.children);

      newProducts.forEach(function (product) {
        currentGrid.appendChild(product);
      });

      const newPaginationData =
        doc.querySelector('#infinite-scroll-data');

      if (newPaginationData) {
        paginationData.dataset.nextUrl =
          newPaginationData.dataset.nextUrl || '';
      } else {
        paginationData.dataset.nextUrl = '';
      }

      /*
       * Give the browser a moment to render the newly
       * inserted products before removing the loader.
       */
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          hideLoader();
          loading = false;
        });
      });

    } catch (error) {
      console.error('Infinite Scroll Error:', error);

      hideLoader();
      loading = false;
    }
  }

  function handleScroll() {
    const scrollPosition =
      window.innerHeight + window.scrollY;

    const pageHeight =
      document.documentElement.scrollHeight;

    if (scrollPosition >= pageHeight - 800) {
      loadMoreProducts();
    }
  }

  /*
   * Create the loader as soon as the page loads.
   */
  createLoader();

  /*
   * Start listening for scrolling.
   */
  window.addEventListener('scroll', handleScroll, {
    passive: true
  });
});